import { TextStyles } from '@/constants';
import type { IMenuItem } from '@/interfaces';
import type React from 'react';
import { AnnouncementLabel } from '../../Header.styles';
import Description from './Description';
import {
  Arrow,
  DropdownContainer,
  DropdownMenuItemTitle,
  DropdownMenuItemWrapper,
  DropdownTitleWrapper,
} from './DropdownMenuItem.styles';
import SecondaryMenuList from './SecondaryMenuList';

const DropdownMenuItem: React.FC<{ data: IMenuItem }> = ({ data }) => {
  const hasDropdown = (data?.innerData && data?.innerData?.length > 0) || data.description;

  return (
    <DropdownMenuItemWrapper>
      <DropdownTitleWrapper>
        <DropdownMenuItemTitle variant={TextStyles['Nav Item Text']}>{data?.title}</DropdownMenuItemTitle>
        {data?.announcementLabel && <AnnouncementLabel>{data?.announcementLabel}</AnnouncementLabel>}
        <Arrow />
      </DropdownTitleWrapper>
      {hasDropdown && (
        <DropdownContainer>
          {data?.innerData && <SecondaryMenuList data={data?.innerData} />}
          {data?.description && <Description data={data?.description} />}
        </DropdownContainer>
      )}
    </DropdownMenuItemWrapper>
  );
};

export default DropdownMenuItem;
